<div class="auth-modal">
    <div class="auth-modal__header">
        <h3>{{ (registered ? 'auth_account_created' : (isLogin ? 'auth_login' : 'auth_sign_up')) | translate }}</h3>
        <button type="button" class="auth-modal__close" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
    </div>

    @if (registered) {
        <div class="auth-modal__success">
            <p class="message">{{ 'auth_registered_message' | translate }}</p>
            <button type="button" class="auth-modal__submit" (click)="activeModal.close()">{{ 'auth_got_it' | translate }}</button>
        </div>
    } @else {
    <form class="auth-modal__body" (ngSubmit)="submit()">
        @if (isLogin) {
            <label class="field">
                <span>{{ 'field_username' | translate }}</span>
                <input ngbAutofocus type="text" name="username" [(ngModel)]="username" (ngModelChange)="errorMessage = ''" autocomplete="username" required />
            </label>
        } @else {
            <label class="field">
                <span>{{ 'field_email' | translate }}</span>
                <input ngbAutofocus type="email" name="email" [(ngModel)]="email" (ngModelChange)="errorMessage = ''" autocomplete="email" required />
            </label>
        }

        <label class="field">
            <span>{{ 'field_password' | translate }}</span>
            <input type="password" name="password" [(ngModel)]="password" (ngModelChange)="errorMessage = ''" autocomplete="current-password" required />
        </label>

        @if (!isLogin) {
            <label class="field">
                <span>{{ 'auth_activation_code' | translate }}</span>
                <input type="text" name="activationCode" [(ngModel)]="activationCode" required />
            </label>
        }

        @if (errorMessage) {
            <p class="auth-modal__error">{{ errorMessage }}</p>
        }

        <button type="submit" class="auth-modal__submit" [disabled]="submitting">
            {{ (isLogin ? 'auth_login' : 'auth_sign_up') | translate }}
        </button>
    </form>

    <div class="auth-modal__footer">
        @if (isLogin) {
            <span>{{ 'auth_no_account' | translate }} <a (click)="switchMode()">{{ 'auth_sign_up' | translate }}</a></span>
        } @else {
            <span>{{ 'auth_have_account' | translate }} <a (click)="switchMode()">{{ 'auth_login' | translate }}</a></span>
        }
    </div>
    }
</div>
